export default "__VITE_ASSET__Cx2vGP4c__"